// Percentage changes are unbounded — a baseline of 1 against a comparator of millions
// yields figures no pill can hold — so anything past a million percent collapses to a
// single "over 1M" reading rather than a number that only differs in digits nobody reads.
// The "%" sits inside the returned string so the "+" overflow marker lands after it.
export const formatChangePct = pct => {
  const abs = Math.abs(pct);
  if (abs >= 1_000_000) return "1M%+";
  if (abs >= 1_000) {
    // Clamped below 1000K: rounding 999,999 up would print "1000K", which reads as a
    // million and contradicts the 1M cap one step above.
    const k = Math.min(999.9, Math.round(abs / 100) / 10);
    return `${k}K%`;
  }
  return `${Math.round(abs)}%`;
};
